import { render, staticRenderFns } from "./StowageInstructionEdit.vue?vue&type=template&id=4757972c&scoped=true"
import script from "./StowageInstructionEdit.vue?vue&type=script&ts=true&lang=js"
export * from "./StowageInstructionEdit.vue?vue&type=script&ts=true&lang=js"
import style0 from "./StowageInstructionEdit.vue?vue&type=style&index=0&id=4757972c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4757972c",
  null
  
)

export default component.exports